<div class="splitFilter w-full">
  <div class="colapse-filter flex justify-content-between align-items-center gap-3">
    <span class="p-input-icon-right w-full">
      <i class="pi pi-search z-1"></i>
      <input #idInputSearch class="w-full" placeholder="Pesquisar" type="text" pInputText /> 
    </span>
    <p-button (onClick)="showFilter = !showFilter" [rounded]="true" [text]="true" severity="secondary">
      <ng-template pTemplate="icon">
          <div class="flex">
              <i class="pi pi-filter p-text-secondary" pBadge severity="danger" [badgeDisabled]="listBadge.length == 0" ></i>
          </div>
      </ng-template>
    </p-button>
  </div>
  <div class="content-filter" *ngIf="showFilter == true">
    <ng-content></ng-content>
  </div>
  <div *ngIf="listBadge.length > 0" class="botton-filter flex gap-2">
    <div class="list-badge flex gap-2">
      <ng-container *ngFor="let badge of listBadge">
        <p-chip [label]="badge.label" removeIcon="pi pi-times" [removable]="true" (onRemove)="removeBadge(badge)" />
      </ng-container>
    </div>
    <p-button class="btn-clear-filter" severity="secondary" (onClick)="clearFilter()" label="limpar filtros" [raised]="true" />
  </div>
</div>
